import React from "react";
import Carousel from "react-material-ui-carousel";
import { Paper, makeStyles, Grid } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
function Item({ parceiro }) {
  const classes = useStyles();
  return (
    <Paper className={classes.root}>
      <Grid container className={classes.conteudo} spacing={5}>
        {parceiro?.map((atual, index) => (
          <Grid key={index} item xs={3}>
            <a href={atual.website} className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
            >
              <img
                key={atual}
                src={atual.logo || atual.image_url}
                alt="Patrocinador"
                className={classes.img}
              />
            </a>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
export default function CarouselParceirosF({ partners }) {
  // All hooks must be called before any early returns
  const isLargeScreen = useMediaQuery("(min-width:960px)");

  // Ensure partners is an array and not empty
  const validPartners = Array.isArray(partners) ? partners : [];
  
  if (validPartners.length === 0) {
    return null; // Don't render if no partners
  }

  let parceiro_por_pagina = 2;
  if (isLargeScreen) parceiro_por_pagina = 4;
  const pages = Array.from(
    Array(Math.ceil(validPartners.length / parceiro_por_pagina)).keys()
  );
  const parceiros = pages.map((page) =>
    validPartners.slice(
      page * parceiro_por_pagina,
      page * parceiro_por_pagina + parceiro_por_pagina
    )
  );
  return (
    <Carousel indicators={false}>
      {parceiros?.map((parceiro, i) => (
        <Item key={i} parceiro={parceiro} />
      ))}
    </Carousel>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  conteudo: {
    width: "100%",
    maxWidth: "1366px",
    alignItems: "center",
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-around",
  },
  img: {
    maxWidth: "100%",
    maxHeight: "260px",
    objectFit: "contain",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "120px",
      maxWidth: "300%",
    },
  },
  link: {
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
}));
